import { twoFactorClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

import { env } from '@/env'

export const authClient = createAuthClient({
  baseURL: env.VITE_APP_URL,
  fetchOptions: { credentials: 'include' },
  plugins: [twoFactorClient()],
})
